var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRenovation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.05 118.62C215.92 137.43 215.78 156.24 215.67 175.05C185.52 192.44 155.36 209.85 125.21 227.24V159.52C155.47 145.89 185.77 132.25 216.05 118.62Z",
    fill: "#72D09A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.52 105.21V179.9L125.23 227.24V159.52L80.38 80.72L35.52 105.21Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9399 97.27C24.4699 99.91 29.99 102.57 35.52 105.21L80.38 80.72C100.47 109.75 120.54 138.77 140.63 167.81C170.77 151.45 200.91 135.1 231.06 118.74C211.05 86.75 191.05 54.75 171.04 22.76C140.82 36.13 110.6 49.51 80.38 62.88C59.9 74.35 39.4199 85.82 18.9399 97.27Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9399 97.2701L35.52 105.21L80.38 80.7201L125.23 159.52L140.63 167.81L80.38 62.9001L18.9399 97.2701Z",
    fill: "#72D09A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3 143.23L52.4701 158.18L61.9401 147.67L57.0001 146.42C59.0901 136.66 67.2701 130.01 76.9301 130.98C85.9001 131.9 93.4001 138.64 96.4401 147.68L103.13 145.62C98.9201 133.72 88.69 124.2 76.8 122.99C63.56 121.64 52.5001 131 50.0201 144.7L45.3 143.23ZM103.92 167.4L108.64 168.87L102.36 153.77L92.2101 163.46L96.4901 164.89C93.4601 172.57 86.3701 177.58 77.8401 176.72C70.2101 175.94 63.6401 171.03 59.9501 163.93L53.4901 166.51C58.5701 176.51 67.6501 183.91 77.9701 184.96C90.0901 186.19 100.28 179 103.92 167.4Z",
    fill: "#FECECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenovation);
export default __webpack_public_path__ + "static/media/renovation.c2e85d35101ab17a55427ec081d1df78.svg";
export { ForwardRef as ReactComponent };